export const SameDayPreorderSettingsType = {
    type: "SameDay",
};
